import {
  createMuiTheme,
  CssBaseline,
  Drawer,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core";
import React from "react";
import Header from "../../../components/Admin/Header";
import red from "@material-ui/core/colors/red";
import MyDrawer from "../../../components/Admin/Drawer";
import Blog from "./Blog";
import { BlogProvider } from "../../../components/Blog/BlogContext";
import { useStyles, theme } from "../theme.js";

const BlogAdminPage = (props) => {
  const classes = useStyles();

  return (
    <BlogProvider>
      <ThemeProvider theme={theme}>
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
          anchor="left"
        >
          <MyDrawer></MyDrawer>
        </Drawer>
        <div className={classes.adminMain}>
          <Header></Header>
          <Blog></Blog>
        </div>
        <CssBaseline></CssBaseline>
      </ThemeProvider>
    </BlogProvider>
  );
};

export default BlogAdminPage;
